// src/utils/logger.ts
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2["Debug"] = "debug";
  LogLevel2["Log"] = "log";
  LogLevel2["Info"] = "info";
  LogLevel2["Warn"] = "warn";
  LogLevel2["Error"] = "error";
  return LogLevel2;
})(LogLevel || {});
var logHandlers = [];
function addLogHandler(handler) {
  logHandlers.push(handler);
}
function getLogger(namespace) {
  function proxy(namespace2, level, msg, ...msgs) {
    logHandlers.forEach((handler) => handler.log(namespace2, level, msg, ...msgs));
  }
  return {
    ["debug" /* Debug */]: proxy.bind(proxy, namespace, "debug" /* Debug */),
    ["log" /* Log */]: proxy.bind(proxy, namespace, "log" /* Log */),
    ["info" /* Info */]: proxy.bind(proxy, namespace, "info" /* Info */),
    ["warn" /* Warn */]: proxy.bind(proxy, namespace, "warn" /* Warn */),
    ["error" /* Error */]: proxy.bind(proxy, namespace, "error" /* Error */),
    metric: proxy.bind(proxy, "Metric", "log" /* Log */)
  };
}
async function logMetric(logger, name, action) {
  const start = Date.now();
  try {
    await action();
    const end = Date.now();
    logger.metric(name, end - start);
  } catch (e) {
    const end = Date.now();
    logger.metric(`${name}-error`, end - start);
    throw e;
  }
}

export {
  LogLevel,
  addLogHandler,
  getLogger,
  logMetric
};
